// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'tribox-solid';

export const Component = () => (
  <>
    <path d='M8.813 16.71V7.896H0v8.812h8.813ZM24.52 9.86V1h-8.81v8.86h8.812Zm0 13.745v-8.86h-8.81v8.86h8.812Z' />
    <path d='m8.813 12.495-.67-.67 7.566-7.568.67.67-7.567 7.568Z' />
    <path d='M15.709 20.35 8.14 12.781l.67-.67 7.568 7.567-.67.67Z' />
  </>
);

export const viewBox = '0 0 25 25';
